import { Link } from 'react-router-dom';
import type { Comic } from '@/types';

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title}封面`}
          title={`${comic.title} 双女主韩漫免费阅读`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur-sm">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-full bg-accent-500/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-950 md:text-base">
          {comic.title}
        </h3>
        <div className="flex flex-wrap gap-1">
          {comic.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">
          {comic.description}
        </p>
        <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-2 text-[11px] text-foreground-500">
          <span className="line-clamp-1 flex items-center gap-1">
            <i className="ri-book-open-line text-accent-500"></i>
            {comic.latestChapter}
          </span>
          <span className="flex shrink-0 items-center gap-1">
            <i className="ri-eye-line"></i>
            {comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}